import { jwtDecode } from "jwt-decode";

/**
 * Returns the decoded JWT payload from sessionStorage, or null if unavailable.
 */
export const getDecodedToken = () => {
  try {
    const token = sessionStorage.getItem("token");
    if (!token) return null;
    return jwtDecode(token);
  } catch (error) {
    console.error("Failed to decode auth token:", error);
    return null;
  }
};

/**
 * Returns the role from the current JWT, or null.
 */
export const getUserRole = () => {
  const decoded = getDecodedToken();
  return decoded?.role || null;
};

/**
 * True when the logged-in user has the SUPER_ADMIN role.
 * Reuses the same role claim checked at login.
 */
export const isSuperAdmin = () => getUserRole() === "SUPER_ADMIN";

/**
 * True when the logged-in user has the given role.
 * @param {string} requiredRole
 */
export const hasRequiredRole = (requiredRole) => {
  if (!requiredRole) return true;
  return getUserRole() === requiredRole;
};
